import * as pathUtils from "../../utils/path/library";
import { constructAdHierarchy } from "../../utils/advertising/library";
import {
    LINKS,
    SCRIPTS,
    NAMES,
    PROPERTIES,
    DEFAULT_PAGE_DESCRIPTION,
} from "./constants";
import { HTTP_OK } from "../../constants/http";
import { AD_IU } from "./constants";
import { PAGE_TYPES } from "../../constants/tracking";

// The Meta record is only for data belonging to the html head tag.
const defaultMetaProps = Object.assign({}, LINKS, SCRIPTS, NAMES, PROPERTIES);

const blankDefaultProps = Object.keys(defaultMetaProps).reduce((acc, key) => {
    acc[key] = "";
    return acc;
}, {});

export const emptyAllMeta = () => {
    return { ...blankDefaultProps };
};

export function generateMeta(props = {}) {
    return { ...defaultMetaProps, ...props };
}

const reduceLookup = (map, val) => {
    map[val] = true;
    return map;
};

export const META_NAMES = Object.keys(NAMES).reduce(reduceLookup, {});
export const META_PROPERTIES = Object.keys(PROPERTIES).reduce(reduceLookup, {});
export const META_LINKS = Object.keys(LINKS).reduce(reduceLookup, {});

export function generateApp(props = {}) {
    const obj = {
        adOrder: "",
        path: "",
        baseSection: "",
        baseNavSection: "",
        subSection: "",
        section: "",
        sponsored: false,
        pageType: "",
        ad_hierarchy: "",
        contentId: "",
        contentType: "",
        title: "CBC.ca",
        meta: generateMeta({}),
        defaultHeadlineImage: "",
        statusCode: HTTP_OK,
        ...props,
    };

    if (!obj.themeClassNames) {
        obj.themeClassNames = pathUtils.getPageClassNames(obj);
    }
    return obj;
}

export const setApp = (app, tracking) => {
    // Update the pageType and the adPageType in the app object
    const pageType = pathUtils.getPageType(app);
    const isDetailPage = pathUtils.isDetail(app);
    const adPageType = isDetailPage ? "story" : "index";
    const adHierarchy = constructAdHierarchy(
        AD_IU,
        app.section,
        pathUtils.isOlympics(app),
        adPageType,
        app.adOrder
    );

    // Set initial app data, relevant to all pages
    app = {
        ...app,
        pageType,
        ad_hierarchy: adHierarchy,
    };

    if (isDetailPage) {
        return app;
    }

    let meta;

    //this custom tracking should be a map, not an array
    if (pageType === PAGE_TYPES.CUSTOM) {
        const obj = pathUtils.isCustomPage(app);
        const title =
            (obj && obj.metadata.pageTitle) || pathUtils.formatMetaTitle(app);
        const defaultDescription = `CBC ${app.baseSection} ${app.subSection} - ${DEFAULT_PAGE_DESCRIPTION}`;

        meta = {
            ...app.meta,
            "og:title": title,
            "og:image": obj.image || "",
            "og:description":
                obj.metadata.pageDescription || defaultDescription,
            description: obj.metadata.pageDescription || defaultDescription,
        };
    } else {
        meta = {
            ...app.meta,
            "og:title": tracking.title,
            "twitter:title": tracking.title,
            "og:image": app.defaultHeadlineImage,
            "twitter:image": app.defaultHeadlineImage,
            "og:description": tracking.description,
            "twitter:description": tracking.description,
            description: tracking.description,
        };
    }

    //return new app state
    return {
        ...app,
        title: tracking.title,
        meta,
    };
};

export const determineBaseNavSectionOverrides = (
    base,
    nav,
    path,
    featureFlags
) => {
    const season = pathUtils.getOlympicsSeason({ path, baseNavSection: nav });
    const ffKey = `olympics.${season}nav`;
    if (season) {
        return featureFlags && ffKey in featureFlags && featureFlags[ffKey]
            ? `olympics-${season}`
            : "sports";
    }
    if (path === "sports/olympics") {
        return featureFlags[`olympics.summernav`]
            ? `olympics-summer`
            : "sports";
    }
    if (path === "sports/paralympics") {
        return featureFlags[`olympics.paralympicsnav`]
            ? `olympics-paralympics`
            : "sports";
    }

    if (nav) return nav.toLocaleLowerCase();

    return base;
};
